import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { type AdvisoryNeedDto, updateAdvisoryNeed } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateAdvisoryNeed = (): UseMutationResult<AdvisoryNeedDto, AxiosError, AdvisoryNeedDto> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (event) => updateAdvisoryNeed({ body: event, path: { id: event.id } }).then((res) => res.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.advisoryNeeds() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
